(function () {
  function pushEvent(name, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, detail || {}));
  }

  var root = document.querySelector('[data-event-view="spoon_product_view"]');
  if (!root) return;

  pushEvent('spoon_product_view', {
    product_id: root.getAttribute('data-product-id')
  });

  function setActiveGalleryMedia(index) {
    root.querySelectorAll('[data-spoon-gallery-slide]').forEach(function (slide) {
      var active = slide.dataset.spoonGallerySlide === index;
      slide.classList.toggle('is-active', active);
      slide.hidden = !active;
    });

    root.querySelectorAll('[data-spoon-gallery-thumb]').forEach(function (thumb) {
      var active = thumb.dataset.spoonGalleryThumb === index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  root.addEventListener('click', function (event) {
    var clickTarget = event.target.closest('[data-event-click]');
    if (clickTarget) {
      pushEvent(clickTarget.getAttribute('data-event-click'));
    }

    var galleryThumb = event.target.closest('[data-spoon-gallery-thumb]');
    if (galleryThumb) {
      setActiveGalleryMedia(galleryThumb.dataset.spoonGalleryThumb);
    }

    var summary = event.target.closest('[data-event-faq-open]');
    if (summary && !summary.parentElement.open) {
      pushEvent(summary.getAttribute('data-event-faq-open'), {
        label: summary.textContent.trim()
      });
    }
  });

  root.addEventListener('focusin', function (event) {
    var focusTarget = event.target.closest('[data-event-focus]');
    if (focusTarget && !focusTarget.dataset.spoonTrackedFocus) {
      focusTarget.dataset.spoonTrackedFocus = 'true';
      pushEvent(focusTarget.getAttribute('data-event-focus'));
    }
  });

  var form = root.querySelector('[data-spoon-product-form]');
  var stickySubmit = root.querySelector('[data-spoon-sticky-submit]');

  if (stickySubmit && form) {
    stickySubmit.addEventListener('click', function () {
      var submitButton = form.querySelector('[type="submit"]');
      if (submitButton) submitButton.click();
    });
  }

  if (form) {
    form.addEventListener('submit', function () {
      pushEvent('spoon_add_to_cart', {
        product_id: root.getAttribute('data-product-id')
      });
    });
  }
})();
